import Vue from 'vue';
import Vuex from 'vuex';

import access from '../access';

Vue.use(Vuex);

export default new Vuex.Store({

  state: {
    user: {
      id: null,
      name: null,
      category: null,
      email: null
    },
    access: {
    },
    search: {
      mode: 0,
      poi: null,
      pano: null,
      cat: null
    },
    node: false
  },
  getters: {
    userdata: state => {
      return state.user
    },
    node: state => {
      return state.node
    }
  },
  mutations: {
    setUser (state, userdata) {      
      //console.log("mutations setUser:");
      state.access = new access(userdata);      
      state.user = userdata;      
    },
    setNode (state, nodedata) {      
      //console.log("mutations setNode:");
      state.access = new access(null);      
      state.node = nodedata;      
      console.log(state.node);
    },    
    clearUser (state) {
      //console.log("mutations clearUser:");
      state.access = new access(null);      
      state.user = {};
    },    
    setSearchMode(state, mode) {
      state.search.mode = mode;            
    },    
    setSearchPoi(state, content) {
      //console.log("setSearchPoi: content: " + content);      
      state.search.poi = content;
      //state.search.cat = cat;
    },
    setSearchPano(state, content) {
      //console.log("setSearchPano: content: " + content);      
      state.search.pano = content;
      //state.search.cat = cat;
    },    
    setSearchLink(state, content) {
      //console.log("setSearchPano: content: " + content);      
      state.search.link = content;
    }        
  }

});
